export default {
  // Login.vue
  'E-Funeral': 'E-Funeral',
  'Email address': 'Email adres',
  'Password': 'Wachtwoord',
  'Wrong username or password.': 'Je gaf een fout e-mailadres of wachtwoord op. Probeer je het opnieuw?',
  'Login': 'Inloggen',
  'Unnamed Video': 'Naamloze video'
}